/// <amd-module name="Build/Admin/Common/Actions/ConfirmationDialogActions" />
import { Action } from "VSS/Reflux/Action";

export class ConfirmationDialogActions<T> {
    public dismissConfirmationDialog = new Action<void>();
    public showConfirmationDialog = new Action<IConfirmationPayload<T>>();
}

export const enum ConfirmButtonType {
    Confirm,
    Update,
    Delete,
    ConfirmDanger
}

export interface IConfirmationPayload<T> {
    selectedItem: T;
    title: string;
    content: string | JSX.Element;
    confirmButtonType: ConfirmButtonType;
    onConfirm(item: T): void;
    onCancel(): void;
}
